import TrackingEvent from "./TrackingEvent.interface";
import sendAll from "./providers";

export default function(Event: TrackingEvent) {
  sendAll(Event);
}
